import React, { useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'is24-corecss'
import type { Swiper as SwiperType } from 'swiper'
import 'swiper/css'
import { AttachmentDataWithRequiredAttachment } from '../../../../../../../../../../@types/types'
import { PictureCard } from './PictureCard'
import { CarouselIndicators } from './CarouselIndicators'
import { CarouselActionButtons } from './CarouselActionButtons'
import styles from './PictureCarousel.module.css'

interface PictureCarouselProps {
  attachments: AttachmentDataWithRequiredAttachment[]
  onEditClick: (attachment: AttachmentDataWithRequiredAttachment) => void
  onAddClick: () => void
  dropzoneId: string
}

export const PictureCarousel: React.FC<PictureCarouselProps> = ({
  attachments,
  onEditClick,
  onAddClick,
  dropzoneId,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const swiperRef = useRef<SwiperType>()

  if (attachments.length === 0) {
    return null
  }

  const currentAttachment = attachments[currentSlide]
  const totalPictures = attachments.length

  const handleSlideChange = (swiper: SwiperType) => {
    setCurrentSlide(swiper.activeIndex)
  }

  const handlePageChange = (index: number) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index)
    }
  }

  return (
    <div className={styles.carouselContainer}>
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        loop={false}
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        onSlideChange={handleSlideChange}
        className={styles.carouselSlider}
      >
        {attachments.map((attachment, index) => (
          <SwiperSlide key={attachment.attachment?.url || index}>
            <PictureCard attachment={attachment} onClick={() => onEditClick(attachment)} />
          </SwiperSlide>
        ))}
      </Swiper>

      <CarouselIndicators
        currentSlide={currentSlide}
        totalPictures={totalPictures}
        currentAttachment={currentAttachment}
      />

      <CarouselActionButtons
        currentAttachment={currentAttachment}
        dropzoneId={dropzoneId}
        onEditClick={onEditClick}
        onAddClick={onAddClick}
      />

      {totalPictures > 1 && (
        <div className={styles.paginationContainer}>
          <Pagination
            type='dot'
            variant='on-image'
            pages={totalPictures}
            activePage={currentSlide}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
  )
}
